import React, { useMemo } from 'react';
import { useWeather } from '../../contexts/WeatherContext';
import { useAuth } from '../../contexts/AuthContext';
import './WeatherAnimations.css';

const WeatherBackground: React.FC = () => {
  const { weather } = useWeather();
  const { user } = useAuth();

  // Respect user preference (default to enabled if not set)
  const isEnabled = user?.preferences?.weather_overlay_enabled !== false;

  const weatherClass = useMemo(() => 
    `weather-bg-${weather.condition}${weather.isNight && (weather.condition === 'Clear' || weather.condition === 'Cloudy') ? '-Night' : ''}`,
    [weather.condition, weather.isNight]
  );
  
  const particlesClass = useMemo(() => 
    `particles-${weather.condition}`,
    [weather.condition]
  );

  if (!isEnabled) return null;

  return (
    <div 
      className={`weather-bg-container ${weatherClass} ${particlesClass}`}
      style={{ 
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: -1,
        pointerEvents: 'none',
        overflow: 'hidden'
      }}
    />
  );
};


export default WeatherBackground;
